import { render, staticRenderFns } from "./CompanyListComponent.vue?vue&type=template&id=456c5990&scoped=true&"
import script from "./CompanyListComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyListComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompanyListComponent.vue?vue&type=style&index=0&id=456c5990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456c5990",
  null
  
)

export default component.exports